<template>
    <div v-if="$route.query.war_id">
        <meter-readings-detail :equipment="currentItem"></meter-readings-detail>
    </div>
    <div v-else class="bg-gray relative z-0">
        <div v-if="profile.isAuth()" class="page-container">
            <div class="px-8 md:px-5 py-5 ">
                <h1 class="mb-6">
                    Meter Readings <i class="fas fa-print font-xl ml-4"></i>
                </h1>
                <equipment-grid
                                @select="selectEquipment"
                                title="Select a device to update meter readings:"
                ></equipment-grid>
            </div>
        </div>
    </div>

    <passcode-pop-up :machineID="$route.query.war_id" :serial="$route.query.serial" @close="goToLogin"></passcode-pop-up>
</template>


<script charset="utf-8">
    import { get } from 'lodash';
    import EquipmentGrid from './includes/EquipmentGrid.vue';
    import MeterReadingsDetail from './MeterReadingsDetail.vue';
    import PasscodePopUp from './includes/PasscodePopUp.vue';
    import { parseEquipment } from '../service/parser';
    import Vuex from 'vuex';

    export default {
        data() {
            return {
                passcodeMessage: '',
                loading: false
            }
        },

        components: {
            EquipmentGrid,
            MeterReadingsDetail,
            PasscodePopUp
        },

        computed: {
            ...Vuex.mapGetters('profile', {
                profile: 'profile',
                hasRole: 'hasRole',
                onPasscodePenalty: 'onPasscodePenalty',
            }),
            ...Vuex.mapGetters('equipments', {
                currentItem: 'currentItem'
            }),
        },
        watch: {
            '$route.query': function (data) {
                if(data.war_id){
                    if(this.currentItem && this.currentItem.id != data.war_id){
                        data.auth = this.profile.isAuth();
                        if(this.$router.currentRoute.value.params.clientID){
                            data.clientID = this.$router.currentRoute.value.params.clientID;
                        }
                        this.findItem(data);
                    }
                }
            }
        },
        created: function () {
            let data = this.$route.query;

            if(this.hasRole){
                if(data.war_id){
                    if(!this.currentItem || this.currentItem.id != data.war_id){
                        data.auth = this.profile.isAuth();
                        if(this.$router.currentRoute.value.params.clientID){
                            data.clientID = this.$router.currentRoute.value.params.clientID;
                        }
                        this.findItem(data);
                    }
                }
            }else{
                if(this.onPasscodePenalty){
                    this.$router.push({ name: 'autologin' });
                    return;
                }
                if(data.war_id){
                    this.loading = true;
                    this.autoLogin(data).then(res => {
                        if(res.has_passcode){
                            this.setShowPopUp(true);
                        }else{
                            this.loginEquipment(parseEquipment(res));
                        }
                    }).catch(() => {
                        this.$router.push({ name: 'autologin', query: this.$route.query });
                    }).finally(() => {
                        this.loading = false;
                    });
                }else{
                    this.$router.push({ name: 'signIn' });
                }
            }
        },
        methods: {
            ...Vuex.mapActions('equipments', {
                findItem: 'findItem',
                autoLogin: 'autoLogin',
            }),
            ...Vuex.mapMutations('equipments', {
                setCurrentItem: 'setCurrentItem'
            }),

            ...Vuex.mapMutations('layout', {
                setShowPopUp: 'setShowPopUp',
            }),

            ...Vuex.mapMutations('profile', {
                loginEquipment: 'loginEquipment'
            }),

            selectEquipment(item) {
                this.setCurrentItem(item);
                this.$router.push({
                    name: 'meterReadings',
                    query: { war_id: item.id, serial: item.serial }
                })
            },
            goToLogin(){
                this.$router.push({ name: 'signIn' });
            }
        }
    }
</script>
